import { render } from "./CollectionSummary.vue?vue&type=template&id=1f45cd77&scoped=true&ts=true"
import script from "./CollectionSummary.vue?vue&type=script&lang=ts"
export * from "./CollectionSummary.vue?vue&type=script&lang=ts"

import "./CollectionSummary.vue?vue&type=style&index=0&id=1f45cd77&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f45cd77"]])

export default __exports__